/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { FC } from 'react';
import {
  ABodyColor,
  ABodySize,
  MLogoContainer,
  MTextBlockSimpleAlignment,
  OMediaCaption,
} from '@marriott/mi-web-ui-kit';
import { OHeroEditorialContainer } from './OHeroEditorial.styles';
//import { HeroEditorialProps } from './HeroEditorial.types';
import { MTextBlockSimple } from '@marriott/mi-web-ui-kit';
import { AspectRatio, MediaQuery, ResponsiveImageSpec } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

const RESPONSIVE_IMAGE_SPECS: ResponsiveImageSpec[] = [
  { media: MediaQuery.MIN_WIDTH_XL, aspectRatio: AspectRatio.STANDARD_HOR, imgWidthPx: 1920 },
  { media: MediaQuery.MIN_WIDTH_LG, aspectRatio: AspectRatio.STANDARD_HOR, imgWidthPx: 992 },
  { media: MediaQuery.MIN_WIDTH_MD, aspectRatio: AspectRatio.SQUARE, imgWidthPx: 768 },
  { media: MediaQuery.MAX_WIDTH_SM, aspectRatio: AspectRatio.SQUARE, imgWidthPx: 576 },
];

export const OHeroEditorial: FC<any> = props => {
  const mTextBlockSimple = {
    eyebrowText: props?.primaryTopic,
    headerText: props?.articleTitle,
    bodyText: props?.authorName,
    alignment: MTextBlockSimpleAlignment.Center,
  };

  const mediaProps = {
    mMediaSelector: {
      ...props?.mMediaSelector,
      mMediaImage: {
        ...props?.mMediaSelector?.mMediaImage,
        aImage: {
          ...props?.mMediaSelector?.mMediaImage?.aImage,
          image: {
            ...props?.mMediaSelector?.mMediaImage?.aImage?.image,
            dynamic: true,
          },
        },
        renditionSpecs: RESPONSIVE_IMAGE_SPECS,
      },
    },
    aBody: {
      bodyText: props?.mMediaSelector?.mMediaImage?.aImage?.caption,
      size: ABodySize.S,
      color: ABodyColor.Alternate,
    },
  };

  return (
    <OHeroEditorialContainer
      className={clsx(props?.styleclass, 'd-flex flex-column align-items-center')}
      data-component-name="hero-editorial"
      data-testid="hero-editorial"
    >
      <div className="container d-flex justify-content-center">
        <MLogoContainer
          brand={props?.brand}
          aspectRatio={props?.aspectRatio}
          width={170}
          height={113}
          alignment={'Centered'}
          color={'background-aware'}
        />
      </div>
      <div className="oheroeditorial-wrapper d-flex flex-column">
        <div className="container">
          <MTextBlockSimple {...mTextBlockSimple} />
        </div>
        <OMediaCaption {...mediaProps} />
      </div>
    </OHeroEditorialContainer>
  );
};

export const OHeroEditorialConfig = {
  emptyLabel: 'OHeroEditorial',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/traveler/articlehero`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OHeroEditorialEditable = (props: any) => (
  <EditableComponent config={OHeroEditorialConfig} {...props}>
    <OHeroEditorial {...props} />
  </EditableComponent>
);
